module.exports = __webpack_public_path__ + "static/media/img_yesco_promotion_s.0b3ea852.png";